<div class="fm-progress-bar--center">
  <invd-fm-progress-bar
    class="fm-progress-bar fm-progress-bar--medium"
    [steps]="steps"
    [currentStep]="currentStep"
    [ignoreRoute]="ignoreRoute"
  >
  </invd-fm-progress-bar>
</div>
<div class="rcr-exchange-container container-fluid">
  <router-outlet></router-outlet>
</div>
